import axios from "axios";
import React, { createContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useCookies } from "react-cookie";
// import { UserContext } from './UserContext'
import moment from "moment";

export const AdminContext = createContext();

function AdminProvider({ children }) {
  const [cookies, removeCookie] = useCookies();
  // const navigate = useNavigate()
  // let apiUrl = "http://localhost:5000/api";
  // let apiUrl = 'https://binnox.herokuapp.com/api'
  let apiUrl = "https://binnox-backend.vercel.app/api";
  const [modalComponentVisible, setModalComponentVisible] =
    React.useState(false);
  const [token, setToken] = React.useState(null);
  const [storedProfile, setStoredProfile] = React.useState(null);
  const [profile, setProfile] = React.useState({
    loading: true,
    data: {},
  });
  const [referralList, setReferralList] = useState({
    loading: true,
    data: [],
  });
  const [referralTotalOrder, setReferralTotalOrder] = useState({
    loading: true,
    totalOrders: [],
  });
  const [referralOrderGrouping, setReferralOrderGrouping] = useState({
    ordersGroupedByDate: {},
    ordersMadeToday: [],
  });

  function logoutFunction() {
    if (window.confirm("You will be logged out of your account !!!")) {
      // localStorage.removeItem("telecomMerchant");

      // setUserAccountInformation([]);
      // setUserProfile([]);
      // setLoggedIn(false);
      removeCookie("BinnoxAmbassador", { path: "/" });
      // navigate("./");
      // window.location('/')
      window.location.href = "/";
    }
  }

  async function getProfileFunction() {
    let data = "";
    // console.log("R-C", cookies);
    console.log(token);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${apiUrl}/ambassador/me`,
      headers: {
        Authorization: token
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Profile: ", response.data);
        setProfile({ data: response.data.profile, loading: false });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  async function getReferralFunction() {
    let data = "";
    // console.log(token);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${apiUrl}/ambassador/referral`,
      headers: {
        Authorization:
          JSON.parse(localStorage.getItem("BinnoxAmbassador"))?.token || token,
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        // console.log("referral: ", response.data.referralList);
        setReferralList({
          data: response.data.referralList.reverse(),
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  useEffect(() => {
    const storedProfile = JSON.parse(localStorage.getItem("BinnoxAmbassador"));
    setStoredProfile(storedProfile);
    // Retrieve data from localStorage
    // console.log("storedProfile", storedProfile);
  }, []);

  useEffect(() => {
    if (storedProfile) {
      setToken(storedProfile?.token);
    }
  }, [storedProfile]);

  useEffect(() => {
    if (token === null) return;

    getReferralOrderFunction();
  }, [referralList, token]);

  async function getReferralOrderFunction() {
    let data = [];
    // if (referralList?.data?.length <= 0) return;
    referralList?.data?.forEach((referral) => {
      data.push(referral._id);
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiUrl}/ambassador/referral/orders`,
      headers: {
        Authorization: token,
      },
      data: { referralsIds: data },
    };

    axios
      .request(config)
      .then((response) => {
        // console.log("referral: ", response.data.referralOrders);

        // const { ordersMadeToday, ordersGroupedByDate } = groupOrderFunction();
        // console.log("***", response.data.referralOrders);
        setReferralTotalOrder((prev) => {
          return {
            totalOrders: response.data.referralOrders,
            loading: false,
          };
        });
        // groupOrderFunction();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    groupOrderFunction();
  }, [referralTotalOrder]);

  function groupOrderFunction() {
    // const moment = require("moment");

    // // Assuming the orders array is named "orders"
    // const orders = [
    //   // Your array of orders goes here...
    // ];

    // Get the current date in the desired format (e.g., "YYYY-MM-DD")
    const currentDate = moment().format("YYYY-MM-DD");

    // Filter the orders made today using the "createdAt" field
    const ordersMadeToday = referralTotalOrder?.totalOrders?.filter((order) =>
      moment(order.createdAt).isSame(currentDate, "day")
    );

    // Group the orders by date (if needed)
    const ordersGroupedByDate = referralTotalOrder?.totalOrders?.reduce(
      (groupedOrders, order) => {
        const orderDate = moment(order.createdAt).format("YYYY-MM-DD");
        if (!groupedOrders[orderDate]) {
          groupedOrders[orderDate] = [];
        }
        groupedOrders[orderDate].push(order);
        return groupedOrders;
      },
      {}
    );

    setReferralOrderGrouping({ ordersGroupedByDate, ordersMadeToday });
    // console.log("Orders:", referralTotalOrder?.totalOrders);
    // console.log("Orders made today:", ordersMadeToday);
    // console.log("Orders grouped by date:", ordersGroupedByDate);
    // return { ordersMadeToday, ordersGroupedByDate };
  }

  return (
    <AdminContext.Provider
      value={{
        apiUrl,
        token,
        setToken,
        profile,
        getProfileFunction,
        referralList,
        setReferralList,
        getReferralFunction,
        getReferralOrderFunction,
        referralTotalOrder,
        referralOrderGrouping,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
}

AdminProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default AdminProvider;
